export function lowercaseAndUnderscore(inputString: string) {
    return inputString.toLowerCase().split(' ').join('_');
}

export const getCategoryPage = (category: string) => {
    if (window.steelcase_finish_library && window.steelcase_finish_library.siteUrl) {
        if (window.steelcase_finish_library.siteUrl.path.includes('eu')) {
            return `fl_emea_${category}`;
        } else if (window.steelcase_finish_library.siteUrl.path.includes('asia')) {
            return `fl_apac_${category}`;
        } else {
            return `fl_amer_${category}`;
        }
    } else {
        return `fl_amer_${category}`;
    }
};

const startsWithNumber = (text: string) => /^\d/.test(text);

export const compareProductLineStrings = (firstString: string, secondString: string) => {
    const isFirstStringNumeric = startsWithNumber(firstString);
    const isSecondStringNumeric = startsWithNumber(secondString);
    if (isFirstStringNumeric !== isSecondStringNumeric) {
        return isFirstStringNumeric ? -1 : 1;
    }

    return firstString.localeCompare(secondString);
};
